export default "__VITE_ASSET__Djkdd61M__"